// prescriptions products slugs
export const PRESCRIPTION_DELIVERY = "prescription-delivery"
export const PRESCRIPTION_DOWNLOAD = "prescription-download"
